import { EMR_APIS } from "@/api_framework/api_config";
import {
  IEMRStaticPrognosisStatusResponse,
  IEMRStaticPrognosisStatusResponseData,
} from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export const useStaticPrognosisAPI = () => {
  const [data, setData] = useState<IEMRStaticPrognosisStatusResponseData[]>(null);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async (clinic_id?: string) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const response: IEMRStaticPrognosisStatusResponseData[] = await axios
        .get(EMR_APIS?.STATIC_PROGNOSIS?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
          params: clinic_id ? { clinic_id } : undefined,
        })
        .then((res: AxiosResponse<IEMRStaticPrognosisStatusResponse>) => {
          if (res.data.status === true) {
            setData(res.data.data);
            return res.data.data;
          } else {
            setData(null);
            return null;
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          setData(null);
          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return { data, execute };
};
